import { render } from "./_name.vue?vue&type=template&id=b2fdab12"
import script from "./_name.vue?vue&type=script&lang=js"
export * from "./_name.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__